import React from "react"
import TextInput from "../TextInput"
import HidePasswordButton from "./HidePasswordButton"
import ViewPasswordButton from "./ViewPasswordButton"
import "./PasswordInput.css"

function RevealButton({ isPasswordShown, toggleReveal }) {
  return (
    <button className="RevealPassword" onClick={toggleReveal}>
      {isPasswordShown ? <HidePasswordButton /> : <ViewPasswordButton />}
    </button>
  )
}

class PasswordInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      reveal: false
    }
  }

  toggleReveal = event => {
    event.preventDefault()
    this.setState({ reveal: !this.state.reveal })
  }

  render() {
    return (
      <span className="PasswordInput">
        <TextInput
          inputType={this.state.reveal ? "text" : "password"}
          placeHolder={this.props.placeHolder}
          name={this.props.name}
        />
        <RevealButton
          isPasswordShown={this.state.reveal}
          toggleReveal={this.toggleReveal}
        />
      </span>
    )
  }
}

export default PasswordInput
